// src/components/SystemRecommendation/components/WhatChanges.tsx

import React from 'react';
import { InstallationScope, ViewMode } from '../types';

interface WhatChangesProps {
  changes: InstallationScope;
  viewMode: ViewMode;
}

const WhatChanges: React.FC<WhatChangesProps> = ({ changes, viewMode }) => {
  return (
    <div className="what-changes">
      <h2 className="section-title">
        {viewMode === 'customer' ? 'What Happens In Your Home' : 'Installation Scope'}
      </h2>

      <div className="changes-grid">
        <div className="stays-section">
          <h3 className="subsection-title">
            {viewMode === 'customer' ? 'What Stays:' : 'STAYS:'}
          </h3>
          <ul className="stays-list">
            {changes.stays.map((item, index) => (
              <li key={index} className="stay-item">
                <span className="check-icon">✓</span>
                {item}
              </li>
            ))}
          </ul>
        </div>

        <div className="changes-section">
          <h3 className="subsection-title">
            {viewMode === 'customer' ? "What's New:" : 'CHANGES:'}
          </h3>
          <ul className="changes-list">
            {changes.changes.map((change, index) => (
              <li key={index} className="change-item">
                <span className="change-icon">
                  {change.isNew ? '⚙️' : '🔄'}
                </span>
                <div className="change-content">
                  <strong>{change.item}</strong>
                  {viewMode === 'technical' && (
                    <span className="change-description">
                      {change.description}
                    </span>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="disruption-timeline">
        <h3 className="subsection-title">
          {viewMode === 'customer' ? 'What To Expect:' : 'DISRUPTION TIMELINE:'}
        </h3>

        <div className="timeline">
          {changes.disruption.timeline.map((day) => (
            <div key={day.day} className="timeline-day">
              <div className="day-label">Day {day.day}:</div>
              <div className="day-activities">
                {day.activities.map((activity, i) => (
                  <p key={i}>{activity}</p>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="disruption-summary">
          <div className="disruption-item">
            <span className="warning-icon">⏰</span>
            <span>
              {viewMode === 'customer' ? 'No hot water: ' : 'Water off: '}
              {changes.disruption.waterOff}
            </span>
          </div>
          <div className="disruption-item">
            <span className="warning-icon">⏰</span>
            <span>
              {viewMode === 'customer' ? 'No heating: ' : 'Heating off: '}
              {changes.disruption.heatingOff}
              {viewMode === 'customer' && " (we'll keep you updated throughout)"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatChanges;
